<template>
    <div
        v-if="showBanner"
        class="fixed bottom-0 left-0 w-full bg-base-100 p-4 shadow-lg z-50 border-t border-base-300 flex flex-col md:flex-row items-center justify-between gap-4"
    >
        <div class="text-sm md:text-base">
            <p>
                Этот сайт использует файлы cookie для аналитики и улучшения
                пользовательского опыта.
            </p>
        </div>
        <div class="flex gap-4">
            <button
                class="inline-flex items-center text-sm md:text-base justify-center w-full px-6 py-2 text-white duration-300 bg-accent rounded-lg hover:bg-accent-dark focus:ring focus:ring-accent-dark focus:ring-opacity-80 btn-sm"
                @click="accept"
            >
                Принять
            </button>
            <button class="btn btn-ghost btn-sm" @click="decline">
                Отклонить
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

const showBanner = ref(false);

const COOKIE_CONSENT_KEY = "cookie_consent_status";

const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift();
};

const setCookie = (name: string, value: string, days: number) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

const accept = () => {
    setCookie(COOKIE_CONSENT_KEY, "accepted", 365);
    window.location.reload();
};

const decline = () => {
    setCookie(COOKIE_CONSENT_KEY, "declined", 365);
    showBanner.value = false;
};

onMounted(() => {
    const status = getCookie(COOKIE_CONSENT_KEY);
    if (!status) {
        showBanner.value = true;
    }
});
</script>
